import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { ColumnApi } from "ag-grid-community";
import { filter } from "rxjs";
import { TimePickerPayload, RelativeTimeRange } from "src/ntx-app/components/time-picker/time-picker.models";

@Injectable({
  providedIn: "root",
})
export class StickinessService {
  private columnApi: ColumnApi | null = null;
  uniqueId = ''; // use a unique identifier for multiple grids on the same page

  constructor(private router: Router) {
    router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.saveGridState();
      });
  }

  setGridContext(api: ColumnApi,uniqueId = ''): void {
    this.columnApi = api;
    this.uniqueId = uniqueId;
  }

  restoreGridState(): void {
    const savedState = localStorage.getItem(
      this.getStorageKey(StickinessState.GridState)
    );
    if (savedState && this.columnApi) {
      try {
        const state = JSON.parse(savedState);
        this.columnApi.applyColumnState({ state, applyOrder: true });
      } catch (e) {
        console.warn("Failed to restore grid state:", e);
      }
    }
  }

  saveGridState(): void {
    if (this.columnApi) {
      const state = this.columnApi.getColumnState();
      if (state?.length) {
        localStorage.setItem(
          this.getStorageKey(StickinessState.GridState),
          JSON.stringify(state)
        );
      }
    }
  }

  saveFilterState(data: object): void {
    if (data) {
      try {
        localStorage.setItem(
          this.getStorageKey(StickinessState.FilterState),
          JSON.stringify(data)
        );
      } catch (e) {
        console.warn("Failed to save filter state:", e);
      }
    }
  }

  restoreFilterState() {
    const saved = localStorage.getItem(
      this.getStorageKey(StickinessState.FilterState)
    );
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.warn("Failed to restore filter state:", e);
        return null;
      }
    }
  }

  saveTimeRangePickerState(state: TimePickerPayload | RelativeTimeRange): void {
    try {
      localStorage.setItem(
        this.getStorageKey(StickinessState.TimeRangePickerState),
        JSON.stringify(state)
      );
    } catch (e) {
      console.warn("Failed to save time range picker state:", e);
    }
  }
  
  restoreTimeRangePickerState(): TimePickerPayload | RelativeTimeRange | null {
    const saved = localStorage.getItem(
      this.getStorageKey(StickinessState.TimeRangePickerState)
    );
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.warn("Failed to restore time range picker state:", e);
        return null;
      }
    }
    return null;
  }

  private getStorageKey(prefix: StickinessState): string {
    const currentUrl = this.router.url.split("?")[0];
    return `${prefix}${currentUrl}${this.uniqueId}`;
  }
}

export enum StickinessState {
  GridState = "gridState__",
  FilterState = "filterState__",
  TimeRangePickerState = "timeRangePickerState__",
}
